// extracted by mini-css-extract-plugin
module.exports = {"videoBox":"index_videoBox_2sTCL","videoContainer":"index_videoContainer_3wTEc","toolBox":"index_toolBox_2V0o4","iconBtn":"index_iconBtn_2J3Nz"};